import { render } from "./CollectionGrid.vue?vue&type=template&id=5e6daf66"
import script from "./CollectionGrid.vue?vue&type=script&lang=js"
export * from "./CollectionGrid.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__